import { PropsWithChildren, useEffect } from 'react';

import { Portal } from '@mui/material';

import { Box, tokens } from '@cast/design-system';

import { useAutoOptimization } from '../_hooks/useAutoOptimization';

// TODO: Replace with a design system full-screen modal component when available.
// This is a hand-rolled Portal + fixed Box used as a temporary stand-in.
export const AutoOptimizationModal = ({
  open,
  children,
}: PropsWithChildren<{ open: boolean }>) => {
  const { onReset } = useAutoOptimization();

  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onReset();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onReset]);
  if (!open) return null;

  return (
    <Portal>
      <Box
        data-testid="autopilot-modal"
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 'modal',
          bgcolor: tokens.theme.bg.structural.surfaceSubtle,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {children}
      </Box>
    </Portal>
  );
};
